import { Loading } from "element-ui"

const loadingDefault = {
  text: "加载中",
  fullscreen: true,
  lock: true,
  spinner: "el-icon-loading",
  background: "rgba(0, 0, 0, 0.7)"
}

// showLoading: let loadingInstance = loadingService()
// closeLoading: loadingInstance.close()
export function loadingService(options = {}) {
  options = Object.assign({}, loadingDefault, options)
  return Loading.service(options)
}

export function isOverflow(el) {
  const range = document.createRange()
  range.setStart(el, 0)
  range.setEnd(el, el.childNodes.length)
  let { height, width } = range.getBoundingClientRect()
  const paddingX =
    (parseInt(el.style["paddingLeft"], 10) || 0) + (parseInt(el.style["paddingRight"], 10) || 0)
  const paddingY =
    (parseInt(el.style["paddingTop"], 10) || 0) + (parseInt(el.style["paddingBottom"], 10) || 0)
  return (
    width + paddingX > el.offsetWidth ||
    el.scrollWidth > el.offsetWidth ||
    height + paddingY > el.offsetHeight ||
    el.scrollHeight > el.offsetHeight
  )
}
